import React from "react";
import { useTranslation } from "react-i18next";
// import Video1 from "../../asset/images/video.mp4";
import { useNavigate } from "react-router-dom";

const WizardMigrate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <h1 className="page-title">Vehicle Model</h1> */}
              </div>

              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <div className="card-title m-0 fs-5 fw-bold">
                      {t("wizardMigrate")}
                    </div>
                    <span className="badge bg-primary">Step 1 of 3</span>
                  </div>

                  <div className="card-body text-center">
                    <p className="mb-3">
                      Get Started: Watch this video to learn how migration works
                    </p>

                    <div
                      className="ratio ratio-16x9 mb-3"
                      style={{ maxWidth: "600px", margin: "auto" }}
                    >
                      <iframe
                        src=""
                        title="Migration Intro Video"
                        allowFullScreen
                      ></iframe>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <button
                        type="button"
                        className="btn btn-primary px-4"
                        onClick={() => {
                          navigate("/dashboard");
                        }}
                      >
                        {t("back")}
                        <i className="bi bi-arrow-left ms-1"></i>
                      </button>

                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-secondary"
                          onClick={() => {
                            navigate("/wizard-migrate-List");
                          }}
                        >
                          {t("skip")}
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            navigate("/wizard-migrate-List");
                          }}
                        >
                          {t("next")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WizardMigrate;
